<template>
  <div :class="['w-full flex flex-col gap-[8px]', containerClass]">
    <!-- text label -->
    <div v-if="label" class="label">
      {{ label }}
    </div>
    <!-- text label -->
    <!-- datePicker -->
    <VueDatePicker
      :id="id"
      :model-value="modelValue"
      @update:model-value="(val) => emit('update:modelValue', val)"
      :locale="local"
      :hide-input-icon="hideInputIcon"
      :action-row="{ showPreview, showSelect, showCancel, showNow }"
      :select-text="selectText"
      :cancel-text="cancelText"
      :preview-format="
        isMonthPicker
          ? formatMonthYear
          : isRange
          ? previewFormatRange
          : $formatDate4
      "
      :format="
        isMonthPicker
          ? formatMonthYear
          : isRange
          ? previewFormatRange
          : $formatDate4
      "
      :min-date="minDate"
      :max-date="isMaxDate ? maxDate : ''"
      :teleport="'body'"
      :enable-time-picker="enableTime"
      :placeholder="placeholder"
      :range="isRange"
      :month-picker="isMonthPicker"
      :ui="ui"
      @cleared="() => emit('update:modelValue', '')"
    >
      <template #input-icon>
        <svg
          v-if="!modelValue || !enableClear"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M15.0781 8.9845C15.5096 8.9845 15.8594 8.63472 15.8594 8.20325C15.8594 7.77177 15.5096 7.422 15.0781 7.422C14.6467 7.422 14.2969 7.77177 14.2969 8.20325C14.2969 8.63472 14.6467 8.9845 15.0781 8.9845Z"
            fill="#555055"
          />
          <path
            d="M16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H9.10156C9.53305 20 9.88281 19.6502 9.88281 19.2188C9.88281 18.7873 9.53305 18.4375 9.10156 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V9.14062C18.4375 9.57211 18.7873 9.92188 19.2188 9.92188C19.6502 9.92188 20 9.57211 20 9.14062V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625Z"
            fill="#555055"
          />
          <path
            d="M15.2734 10.5469C12.6672 10.5469 10.5469 12.6672 10.5469 15.2734C10.5469 17.8797 12.6672 20 15.2734 20C17.8797 20 20 17.8797 20 15.2734C20 12.6672 17.8797 10.5469 15.2734 10.5469ZM15.2734 18.4375C13.5288 18.4375 12.1094 17.0181 12.1094 15.2734C12.1094 13.5288 13.5288 12.1094 15.2734 12.1094C17.0181 12.1094 18.4375 13.5288 18.4375 15.2734C18.4375 17.0181 17.0181 18.4375 15.2734 18.4375Z"
            fill="#555055"
          />
          <path
            d="M16.4062 14.4922H16.0547V13.6719C16.0547 13.2404 15.7049 12.8906 15.2734 12.8906C14.842 12.8906 14.4922 13.2404 14.4922 13.6719V15.2734C14.4922 15.7049 14.842 16.0547 15.2734 16.0547H16.4062C16.8377 16.0547 17.1875 15.7049 17.1875 15.2734C17.1875 14.842 16.8377 14.4922 16.4062 14.4922Z"
            fill="#555055"
          />
          <path
            d="M11.6797 8.9845C12.1112 8.9845 12.4609 8.63472 12.4609 8.20325C12.4609 7.77177 12.1112 7.422 11.6797 7.422C11.2482 7.422 10.8984 7.77177 10.8984 8.20325C10.8984 8.63472 11.2482 8.9845 11.6797 8.9845Z"
            fill="#555055"
          />
          <path
            d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
            fill="#555055"
          />
          <path
            d="M4.88281 8.9845C5.31428 8.9845 5.66406 8.63472 5.66406 8.20325C5.66406 7.77177 5.31428 7.422 4.88281 7.422C4.45134 7.422 4.10156 7.77177 4.10156 8.20325C4.10156 8.63472 4.45134 8.9845 4.88281 8.9845Z"
            fill="#555055"
          />
          <path
            d="M4.88281 12.3827C5.31428 12.3827 5.66406 12.0329 5.66406 11.6014C5.66406 11.17 5.31428 10.8202 4.88281 10.8202C4.45134 10.8202 4.10156 11.17 4.10156 11.6014C4.10156 12.0329 4.45134 12.3827 4.88281 12.3827Z"
            fill="#555055"
          />
          <path
            d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
            fill="#555055"
          />
          <path
            d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
            fill="#555055"
          />
          <path
            d="M8.28125 8.98437C8.71272 8.98437 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98437 8.28125 8.98437Z"
            fill="#555055"
          />
        </svg>
      </template>

      <template #clear-icon="{ clear }">
        <svg
          v-if="enableClear"
          @click="clear"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M17.6924 7.79254C18.1025 7.38247 18.1025 6.71762 17.6924 6.30755C17.2824 5.89748 16.6175 5.89748 16.2075 6.30755L12 10.515L7.79255 6.30755C7.38248 5.89748 6.71763 5.89748 6.30756 6.30755C5.8975 6.71762 5.8975 7.38247 6.30756 7.79254L10.515 12L6.30755 16.2075C5.89748 16.6175 5.89748 17.2824 6.30755 17.6924C6.71762 18.1025 7.38247 18.1025 7.79254 17.6924L12 13.485L16.2075 17.6924C16.6175 18.1025 17.2824 18.1025 17.6925 17.6924C18.1025 17.2824 18.1025 16.6175 17.6925 16.2075L13.485 12L17.6924 7.79254Z"
            fill="#555055"
          />
        </svg>
      </template>

      <template #calendar-icon>
        <div
          class="w-[36px] h-[36px] flex items-center justify-center rounded-[6px] border-[1px] border-solid border-[#B7B2B5]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M15.0781 8.9845C15.5096 8.9845 15.8594 8.63472 15.8594 8.20325C15.8594 7.77177 15.5096 7.422 15.0781 7.422C14.6467 7.422 14.2969 7.77177 14.2969 8.20325C14.2969 8.63472 14.6467 8.9845 15.0781 8.9845Z"
              fill="#9B237B"
            />
            <path
              d="M16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H9.10156C9.53305 20 9.88281 19.6502 9.88281 19.2188C9.88281 18.7873 9.53305 18.4375 9.10156 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V9.14062C18.4375 9.57211 18.7873 9.92188 19.2188 9.92188C19.6502 9.92188 20 9.57211 20 9.14062V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625Z"
              fill="#9B237B"
            />
            <path
              d="M15.2734 10.5469C12.6672 10.5469 10.5469 12.6672 10.5469 15.2734C10.5469 17.8797 12.6672 20 15.2734 20C17.8797 20 20 17.8797 20 15.2734C20 12.6672 17.8797 10.5469 15.2734 10.5469ZM15.2734 18.4375C13.5288 18.4375 12.1094 17.0181 12.1094 15.2734C12.1094 13.5288 13.5288 12.1094 15.2734 12.1094C17.0181 12.1094 18.4375 13.5288 18.4375 15.2734C18.4375 17.0181 17.0181 18.4375 15.2734 18.4375Z"
              fill="#9B237B"
            />
            <path
              d="M16.4062 14.4922H16.0547V13.6719C16.0547 13.2404 15.7049 12.8906 15.2734 12.8906C14.842 12.8906 14.4922 13.2404 14.4922 13.6719V15.2734C14.4922 15.7049 14.842 16.0547 15.2734 16.0547H16.4062C16.8377 16.0547 17.1875 15.7049 17.1875 15.2734C17.1875 14.842 16.8377 14.4922 16.4062 14.4922Z"
              fill="#9B237B"
            />
            <path
              d="M11.6797 8.9845C12.1112 8.9845 12.4609 8.63472 12.4609 8.20325C12.4609 7.77177 12.1112 7.422 11.6797 7.422C11.2482 7.422 10.8984 7.77177 10.8984 8.20325C10.8984 8.63472 11.2482 8.9845 11.6797 8.9845Z"
              fill="#9B237B"
            />
            <path
              d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
              fill="#9B237B"
            />
            <path
              d="M4.88281 8.9845C5.31428 8.9845 5.66406 8.63472 5.66406 8.20325C5.66406 7.77177 5.31428 7.422 4.88281 7.422C4.45134 7.422 4.10156 7.77177 4.10156 8.20325C4.10156 8.63472 4.45134 8.9845 4.88281 8.9845Z"
              fill="#9B237B"
            />
            <path
              d="M4.88281 12.3827C5.31428 12.3827 5.66406 12.0329 5.66406 11.6014C5.66406 11.17 5.31428 10.8202 4.88281 10.8202C4.45134 10.8202 4.10156 11.17 4.10156 11.6014C4.10156 12.0329 4.45134 12.3827 4.88281 12.3827Z"
              fill="#9B237B"
            />
            <path
              d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
              fill="#9B237B"
            />
            <path
              d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
              fill="#9B237B"
            />
            <path
              d="M8.28125 8.98437C8.71272 8.98437 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98437 8.28125 8.98437Z"
              fill="#9B237B"
            />
          </svg>
        </div>
      </template>

      <template #year="{ value, year }">
        <span v-if="isMonthPicker">
          {{ year + 543 }}
        </span>
        <span v-else>{{ value + 543 }}</span>
      </template>
      <template #year-overlay-value="{ value }">
        <span v-if="value">
          {{ value + 543 }}
        </span>
        <span v-else class="line"></span>
      </template>
    </VueDatePicker>
    <!-- datePicker -->
    <!-- text error -->
    <div
      v-if="warningMessage"
      :class="['textError', { 'mt-[8px]': warningMessage }]"
    >
      {{ warningMessage }}
    </div>
    <!-- text error -->
  </div>
</template>

<script setup>
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { computed, onMounted } from "vue";

const props = defineProps({
  containerClass: {
    type: String,
  },
  label: {
    type: String,
  },
  id: {
    type: String,
    default: () => {
      return "datePicker";
    },
  },
  local: {
    type: String,
    default: () => {
      return "th";
    },
  },
  // hide input icon
  hideInputIcon: {
    type: Boolean,
    default: () => {
      return false;
    },
  },
  // hide input icon
  showPreview: {
    type: Boolean,
    default: () => {
      return true;
    },
  },
  showSelect: {
    type: Boolean,
    default: () => {
      return true;
    },
  },
  showCancel: {
    type: Boolean,
    default: () => {
      return true;
    },
  },
  showNow: {
    type: Boolean,
    default: () => {
      return false;
    },
  },
  selectText: {
    type: String,
    default: () => {
      return "ตกลง";
    },
  },
  ui: {
    type: Object,
    default: () => ({}),
  },
  cancelText: {
    type: String,
    default: () => {
      return "ปิด";
    },
  },
  previewFormat: {
    type: Function,
  },
  format: {
    type: Function,
    default: () => (date) => date,
  },
  minDate: {
    type: [String, Date],
  },
  isMaxDate: {
    type: Boolean,
    default: () => {
      return true;
    },
  },
  maxDate: {
    type: [String, Date],
    default: () => {
      let date = new Date();
      date.setHours(23, 59, 59, 0);
      return date;
    },
  },
  placeholder: {
    type: String,
    default: () => {
      return "เลือกวันที่";
    },
  },
  enableClear: {
    type: Boolean,
    default: () => {
      return true;
    },
  },
  enableTime: {
    type: Boolean,
    default: () => {
      return false;
    },
  },
  isRange: {
    type: Boolean,
    default: () => {
      return false;
    },
  },
  isMonthPicker: {
    type: Boolean,
    default: () => {
      return false;
    },
  },
  isTimePicker: {
    type: Boolean,
    default: () => {
      return false;
    },
  },
  modelValue: {
    type: [String, Date],
    default: () => {
      return new Date();
    },
  },
  warningMessage: {
    type: String,
  },
});

const emit = defineEmits(["update:modelValue"]);

onMounted(async () => {
  // if (!isRange) {
  //   previewFormatSingle();
  // } else {
  //   previewFormatRange();
  // }
});

// const previewFormatSingle = (date) => {
//   if (!date) return "ยังไม่ได้เลือกวัน";

//   const monthsTH = [
//     "ม.ค.",
//     "ก.พ.",
//     "มี.ค.",
//     "เม.ย.",
//     "พ.ค.",
//     "มิ.ย.",
//     "ก.ค.",
//     "ส.ค.",
//     "ก.ย.",
//     "ต.ค.",
//     "พ.ย.",
//     "ธ.ค.",
//   ];

//   const d = new Date(date);
//   const day = d.getDate();
//   const month = monthsTH[d.getMonth()];
//   const year = d.getFullYear() + 543;

//   return `${day} ${month} ${year}`;
// };

const formatMonthYear = (date) => {
  // console.log("formatMonthYear", date);

  if (!date) return "";
  const monthsTH = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];
  const d = new Date(date);
  const month = monthsTH[d.getMonth()];
  const year = d.getFullYear() + 543;
  return `${month} ${year}`;
};

const previewFormatRange = (dates) => {
  // console.log("previewFormatRange", dates);

  if (!Array.isArray(dates) || !dates[0] || !dates[1]) {
    return "";
  }

  const monthsTH = [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ];

  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate();
    const month = monthsTH[d.getMonth()];
    const year = d.getFullYear() + 543;
    return `${day} ${month} ${year}`;
  };

  return `${formatDate(dates[0])} - ${formatDate(dates[1])}`;
};
</script>

<style lang="scss" scoped>
.label {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
.line {
  border-top: 1px solid #b7b2b5;
}
</style>

<!-- datePicker -->
<style lang="scss">
.dp__input {
  padding: 10px;
  padding-right: 36px;
  max-height: 42px;
  border: 1px solid #b7b2b5;
}
.dp__input::placeholder {
  color: #b7b2b5;
  /* PC font/PC_Body2-R */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
}
.dp__input_icon {
  right: 10px;
  display: flex;
  justify-content: flex-end;
  transform: translate(0%, -50%);
}
.dp--clear-btn {
  right: 10px;
  display: flex;
  justify-content: flex-end;
  transform: translate(0%, -50%);
}
.dp__arrow_top {
  display: none;
}
.dp__menu_inner,
.dp__action_row {
  padding: 0px;
}
.dp__action_row {
  display: flex;
  flex-direction: column;
  // gap: 10px;
}
.dp__selection_preview[title] {
  width: 100%;
  border-top: 1px solid #dfdcdd;
}
.dp__selection_preview[title]:not([title=""]) {
  max-width: unset !important;
  text-align: center;
  padding: 10px;
  // background-color: #fbeff8;
}
.dp__today {
  background: #eecce7 !important;
  color: #9b237b !important;
  border: none !important;
}
.dp__action_buttons {
  width: 100%;
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 6px;
  align-self: stretch;
}
.dp__action_button {
  width: 100%;
  height: 42px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 16px;
  gap: 4px;
  border-radius: 6px;
}
.dp__action_cancel {
  border: 1px solid #b7b2b5;
  background: #fff;
}
.dp__action_select {
  border-radius: 6px;
  background: #9b237b;
}
.dp__calendar_header_item,
.dp__month_year_select,
.dp__cell_inner {
  // color: #1f1d1f;
  text-align: center;
  /* PC font/PC_Body2-R */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
}
.dp__cell_offset {
  color: #dfdcdd;
}
// .dp--future {
//   color: #dfdcdd;
// }
.dp__cell_disabled {
  color: #dfdcdd;
}
.dp--arrow-btn-nav {
  min-width: 42px;
  min-height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dp__month_year_wrap {
  align-items: center;
}
.dp__calendar .dp__calendar {
  padding: 6px;
  // border-bottom: 1px solid #b7b2b5;
}
.dp__calendar_row:last-child {
  margin: 0;
}
.dp__calendar_row:not(:last-child) {
  margin: 0 0 10px 0;
}
.dp__overlay_cell_active,
.dp__active_date {
  background: #eecce7 !important;
  color: #9b237b !important;
  border: 1px solid #9b237b !important;
}
.dp__overlay_cell_active {
  border: 1px solid #c479b1;
}
.dp__calendar_header_separator {
  background: #b7b2b5;
}
.dp__menu_index {
  border: 1px solid #b7b2b5 !important;
}
.dp__overlay_action {
  height: auto;
  padding: 6px 10px;
  // border-bottom: 1px solid #dfdcdd;
}
</style>
